var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("this is Celebrities page")]),_c('v-btn',{on:{"click":_vm.goHome}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }